"use strict";
/**
 * This class provides the colormixer function
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Color;
(function (Color) {
    Color[Color["RED"] = 1] = "RED";
    Color[Color["BLUE"] = 2] = "BLUE";
    Color[Color["GREEN"] = 3] = "GREEN";
    Color[Color["ORANGE"] = 4] = "ORANGE";
    Color[Color["YELLOW"] = 5] = "YELLOW";
    Color[Color["PURPLE"] = 6] = "PURPLE";
    Color[Color["COMPLEMENT"] = 7] = "COMPLEMENT";
    Color[Color["BLACK"] = 8] = "BLACK";
    Color[Color["WHITE"] = 9] = "WHITE";
})(Color = exports.Color || (exports.Color = {}));
exports.mixColors = (color1, color2) => {
    if (color1 === Color.YELLOW) {
        if (color2 === Color.YELLOW) {
            return Color.YELLOW;
        }
        if (color2 === Color.ORANGE) {
            return Color.ORANGE;
        }
        if (color2 === Color.RED) {
            return Color.ORANGE;
        }
        if (color2 === Color.PURPLE) {
            return Color.BLACK;
        }
        if (color2 === Color.BLUE) {
            return Color.GREEN;
        }
        if (color2 === Color.GREEN) {
            return Color.GREEN;
        }
        if (color2 === Color.COMPLEMENT) {
            return Color.PURPLE;
        }
    }
    if (color1 === Color.ORANGE) {
        if (color2 === Color.YELLOW) {
            return Color.ORANGE;
        }
        if (color2 === Color.ORANGE) {
            return Color.ORANGE;
        }
        if (color2 === Color.RED) {
            return Color.ORANGE;
        }
        if (color2 === Color.PURPLE) {
            return Color.RED;
        }
        if (color2 === Color.BLUE) {
            return Color.BLACK;
        }
        if (color2 === Color.GREEN) {
            return Color.YELLOW;
        }
        if (color2 === Color.COMPLEMENT) {
            return Color.BLUE;
        }
    }
    if (color1 === Color.RED) {
        if (color2 === Color.YELLOW) {
            return Color.ORANGE;
        }
        if (color2 === Color.ORANGE) {
            return Color.ORANGE;
        }
        if (color2 === Color.RED) {
            return Color.RED;
        }
        if (color2 === Color.PURPLE) {
            return Color.PURPLE;
        }
        if (color2 === Color.BLUE) {
            return Color.PURPLE;
        }
        if (color2 === Color.GREEN) {
            return Color.BLACK;
        }
        if (color2 === Color.COMPLEMENT) {
            return Color.GREEN;
        }
    }
    if (color1 === Color.PURPLE) {
        if (color2 === Color.YELLOW) {
            return Color.BLACK;
        }
        if (color2 === Color.ORANGE) {
            return Color.RED;
        }
        if (color2 === Color.RED) {
            return Color.PURPLE;
        }
        if (color2 === Color.PURPLE) {
            return Color.PURPLE;
        }
        if (color2 === Color.BLUE) {
            return Color.PURPLE;
        }
        if (color2 === Color.GREEN) {
            return Color.BLUE;
        }
        if (color2 === Color.COMPLEMENT) {
            return Color.YELLOW;
        }
    }
    if (color1 === Color.BLUE) {
        if (color2 === Color.YELLOW) {
            return Color.GREEN;
        }
        if (color2 === Color.ORANGE) {
            return Color.BLACK;
        }
        if (color2 === Color.RED) {
            return Color.PURPLE;
        }
        if (color2 === Color.PURPLE) {
            return Color.PURPLE;
        }
        if (color2 === Color.BLUE) {
            return Color.BLUE;
        }
        if (color2 === Color.GREEN) {
            return Color.GREEN;
        }
        if (color2 === Color.COMPLEMENT) {
            return Color.ORANGE;
        }
    }
    if (color1 === Color.GREEN) {
        if (color2 === Color.YELLOW) {
            return Color.GREEN;
        }
        if (color2 === Color.ORANGE) {
            return Color.YELLOW;
        }
        if (color2 === Color.RED) {
            return Color.BLACK;
        }
        if (color2 === Color.PURPLE) {
            return Color.BLUE;
        }
        if (color2 === Color.BLUE) {
            return Color.GREEN;
        }
        if (color2 === Color.GREEN) {
            return Color.GREEN;
        }
        if (color2 === Color.COMPLEMENT) {
            return Color.RED;
        }
    }
    if (color1 === Color.COMPLEMENT) {
        if (color2 === Color.YELLOW) {
            return Color.PURPLE;
        }
        if (color2 === Color.ORANGE) {
            return Color.BLUE;
        }
        if (color2 === Color.RED) {
            return Color.GREEN;
        }
        if (color2 === Color.PURPLE) {
            return Color.YELLOW;
        }
        if (color2 === Color.BLUE) {
            return Color.ORANGE;
        }
        if (color2 === Color.GREEN) {
            return Color.RED;
        }
        if (color2 === Color.COMPLEMENT) {
            return Color.COMPLEMENT;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/colormixer.ts
// module id = 5
// module chunks = 0